export const RoundArrowUp = ({ className }: { className: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M8.66699 8.00004H13.3337L8.00033 2.66671L2.66699 8.00004H7.33366V13.3334H8.66699V8.00004Z"
        fill="#09121F"
      />
    </svg>
  );
};
